import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { publicSelector } from './selector';

interface IState {
  tenants: any[];
  publics: any[];
}

export const PublicHook = () => {
  const publicState = useSelector(publicSelector.getPublic);

  const [state, setState] = useState<IState>({
    tenants: publicState.tenants,
    publics: publicState.publics,
  });

  useEffect(() => {
    setState({
      tenants: publicState.tenants,
      publics: publicState.publics,
    });
  }, [publicState]);

  return state;
};
